/* eslint-disable react/jsx-no-useless-fragment */
import React, {
  useState, useEffect, forwardRef, useImperativeHandle,
} from 'react';
import { createPortal } from 'react-dom';
import { IoMdClose } from 'react-icons/io';
import { animated, useSpring } from 'react-spring';
import styles from './modal.module.scss';

export type IModalHandle = {
  toggle: () => void,
  open: () => void,
  close:() => void,
};

const ModalStandalone = forwardRef<IModalHandle, any>(({
  children,
  displayClose = false,
  domNode = 'modal',
}:{
  children: JSX.Element,
  displayClose: boolean,
  domNode: string
}, ref) => {
  const modalRoot = document.getElementById(domNode);
  const [open, setOpen] = useState(false);
  const [toggleAnimation, setToggleAnimation] = useState(false);

  useImperativeHandle(ref, () => ({
    toggle: () => setOpen((state) => !state),
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));

  function toggle() { setOpen((state) => !state); }

  function close() {
    if (!displayClose) {
      return null;
    }
    return setToggleAnimation(false);
  }

  const spring = useSpring({
    opacity: toggleAnimation ? 1 : 0,
    onRest: (state) => {
      if (state.value.opacity === 0) toggle();
    },
  });

  useEffect(() => {
    if (!ref) console.error('ModalStandalone components need require a ref');
  }, [ref]);

  useEffect(() => {
    if (!modalRoot) {
      console.error(`Can't find the dom element (#${domNode}) where this modal should be mount \nYou should add a div with id : "${domNode}" to public/index.html
     `);
    }
  }, [modalRoot, domNode]);

  useEffect(() => {
    if (open) {
      setToggleAnimation(true);
    }
  }, [open]);

  return (
    <>
      {modalRoot
        && (
        <>
          {createPortal(
            <>
              {(ref && open)
                && (
                <>
                  <animated.div
                    style={{ ...spring }}
                    className={styles['overlay-modal']}
                    onClick={close}
                  />
                  <animated.div
                    style={{ ...spring }}
                    className={styles.modal}
                  >
                    {children}
                    {displayClose
                      && <button onClick={close} className={styles.close}>
                        <IoMdClose />
                      </button>
                    }
                  </animated.div>
                </>
                )}
            </>,
            modalRoot,
          )}
        </>
        )}
    </>
  );
});
ModalStandalone.displayName = 'ModalStandalone';
export default ModalStandalone;
